if (!customElements.get('cart-notification')) {
  class CartNotification extends HTMLElement {
    static ACTIVE_CLASS = 'is-open';

    constructor() {
      super();
    }

    open() {
      this.classList.add(CartNotification.ACTIVE_CLASS);
    }

    close() {
      this.classList.remove(CartNotification.ACTIVE_CLASS);
    }

    handleCartAdded(event) {
      this.titleElement.innerHTML = event.detail.title;
      this.image.src = event.detail.image;

      requestAnimationFrame(() => {
        this.open();
      });

      setTimeout(() => {
        this.close();
      }, 3000);
    }

    handleClick(event) {
      const target = event.target.closest('a');

      if (!target) return;
      if (!target.hasAttribute('js-close')) return;

      event.preventDefault();

      this.close();
    }

    connectedCallback() {
      this.titleElement = this.querySelector('[js-title]');
      this.image = this.querySelector('[js-image]');
      this.price = this.querySelector('[js-price]');

      this.addEventListener('click', this.handleClick.bind(this));

      document.addEventListener(
        'cart:added',
        this.handleCartAdded.bind(this),
        false,
      );
    }
  }

  customElements.define('cart-notification', CartNotification);
}
